import { getReportData, setReportDoc } from 'store/store';
var XMLParser = require('react-xml-parser');

export var reportDoc = null;
export function parseXmlFile() {
  const xmlData = getReportData();

  var parser = new XMLParser();
  reportDoc = parser.parseFromString(xmlData);
  //console.log("reportDoc: ", reportDoc);

  return reportDoc;
}

export function formatFullName(element) {
  //console.log('element: ',typeof element, element);
  if (element === undefined) return '';
  const fn = getAttrValue(element, "_FirstName");
  const mn = getAttrValue(element, "_MiddleName");
  const ln = getAttrValue(element, "_LastName");
  var gen = getAttrValue(element, "_NameSuffix");
  //console.log(fn,mn,ln, gen);
  var name = appendWithSpace(fn, mn);
  name = appendWithSpace(name, ln);
  name = appendWithSpace(name, gen);
  return name;
}

export function formatFullAddress(element) {
  //console.log('element: ',typeof element, element);
  if (element === undefined) return '';
  var a = getAttrValue(element, "_StreetAddress");
  const c = getAttrValue(element, "_City");
  const s = getAttrValue(element, "_State");
  const p = getAttrValue(element, "_PostalCode");
  //console.log("addr: ", a1, a2, c, s, p);
  a = appendWithComma(a, c);
  a = appendWithComma(a, s);
  a = appendWithSpace(a, p);
  return a;
}

export function formatSSN(element) {
  //console.log('element: ',element);
  if (element === undefined) return '';
  var ssnin = getAttrValue(element, "_SSN");
  //console.log("ssnin: ", ssnin);
  if (ssnin === undefined) return '';
  var ssn = ssnin.substring(0,3) + '-' + ssnin.substring(3,5) + '-' + ssnin.substring(5);
  //console.log("ssn: ", ssn);
  return ssn;
}

export function appendWithSpace(s1, s2) {
  //console.log(s1, s2);
  var s;
  if (isEmpty(s2)) return s1;
  s = s1 + ' ' + s2;
  return s;
}

export function appendWithComma(s1, s2) {
  //console.log(s1, s2, typeof s2, s2.length);
  var s;
  if (isEmpty(s2)) return s1;
  s = s1 + ', ' + s2;
  return s;
}

export function isEmpty(value) {
  //console.log(typeof value);
  if (value == undefined) { return true; }
  if (value == null) { return true; }

  if (typeof value !== 'object') {
    // boolean, number, string, function, etc.
    if (typeof value === 'string') {
    var result = (value === '') ? true : false;
    return result;
    }
  }
    
  for (const prop in value) {
    if (Object.hasOwn(value, prop)) {
      return false;
    }
  }

  return true;
}

export function getTagValue(element, tag) {
	let value = '';
  let el = element[tag]
  //console.log("el: ", el);
  if (el === undefined) return '';
  if (el.length !== 0) value = el._text;
  if (value === undefined) value = el._number;
  //console.log("val: ", value);
  if (value === undefined) return '';
  return value;
}

export function getAttrValue(element, tag) {
	let attr = element._attributes;
  //console.log("attr: ", attr);
  let value = attr[tag];
  //console.log("attr value: ", value);
  return value;
}

export function getTagAttrValue(element, tag, attr) {
  let ele = element[tag];
  //console.log("ele: ", ele);
  if (!ele) return '';
	let atr = ele._attributes;
  //console.log("atr: ", atr);
  if (!atr) return '';
  let value = atr[attr];
  if (!ele) return '';
  //console.log("TAGattr value: ", value);
  return value;
}

export function formatDateMY(d) {
	if (!d) return '';
	var date = d;
	var fmt = '';
	var parts = date.split('-');
	//console.log(parts);
	if (parts.length === 2) {
		fmt = parts[1] + '/';
		fmt = fmt + parts[0].slice(-2);
	} else if (parts.length === 3) {
		fmt = parts[1] + '/';
		fmt = fmt + parts[0].slice(-2);
	}
	return fmt;
}

export function formatDateMDY(d) {
  //console.log("formatDate: ", d);
	if (!d) return '';
	var date = d;
  var ix = date.indexOf('T');
  if (ix > 0) date = date.substring(0, ix);
	var fmt = '';
	var parts = date.split('-');
	//console.log(parts);
	if (parts.length === 2) {
		fmt = parts[1] + '/';
		fmt = fmt + parts[0].slice(-2);
	} else if (parts.length === 3) {
		fmt = parts[1] + '/';
		fmt = fmt + parts[2] + '/';
		fmt = fmt + parts[0].slice(-2);
	}
	//console.log(fmt);

	return fmt;
}

export function formatPhone(number) {
	if (number === '') return '';
  if (isNaN(number[0])) return number;
	if (number.length != 10) return number;
	var phone = number.substring(0,3) + '-' + number.substring(3,6) + '-' + number.substring(6);
	//console.log( phone);

	return phone;
}

export function trim(s, l) {
  if (!s) return '';
  if (s.length <= l) return s;
  return s.substring(0, l);
}

export function getEleArray(element, tag) {
  //console.log("EleArray: ", typeof element, element.length, element);
  let e = element[tag];
  if (e === undefined) return null;
  //console.log("e: ", typeof e, e.length, e);
  let a = new Array();
  if (e.length === undefined) {
    a.push(e);
  } else {
    e.forEach((e) => {a.push(e)});
  };

  //console.log("array: ", typeof a, a.length, a);
  return a;
}
